import SkeletonPulse from './SkeletonPulse';

const PlayerSkeleton = () => {
  return <SkeletonPulse classname="w-3/5 h-3/5" />;
};

const menuItems = new Array(7).fill(0);

// Right customizer rail placeholder (matches the vertical tool rail in the loaded editor).
const ClipCustomizerSkeleton = () => {
  return (
    <div className="absolute right-0 top-2 z-[55] flex flex-col items-center gap-2 pr-1">
      {menuItems.map((_, index) => (
        <SkeletonPulse key={index} classname="size-10 rounded-lg" />
      ))}
    </div>
  );
};

const ClipPlayerSkeleton = () => {
  return (
    <div className="relative flex size-full items-center justify-center">
      <PlayerSkeleton />
      <ClipCustomizerSkeleton />
    </div>
  );
};

export default ClipPlayerSkeleton;
